import { useAuth0 } from "@auth0/auth0-react";
import RadioButtons from 'components/RadioButtons/RadioButtons';
import { checkIsStripe } from "helper/checkIsStripe";
import AuthService from "Lib/API/Auth";
import React, { useMemo, useState } from "react";
import { toastr } from "react-redux-toastr";
import FinanceService from "../../Lib/API/Finance";
import { withUserExist } from "../CustomHooks";
import AchMethod from "./AchMethod";
import CreditCardMethod from "./CreditCardMethod";
import "./index.scss";

const PaymentMethods = ({activePaymentParams}) => {
const paymentMethod = JSON.parse(localStorage.getItem("paymentMethodCreditCard"));
const achPaymentMethod = JSON.parse(localStorage.getItem("paymentMethodAch"));

  const isAchStripe = checkIsStripe(achPaymentMethod);
  const enableAchPaymentMethod = useMemo(() => {
    return isAchStripe && achPaymentMethod?.allow_member;
  }, [isAchStripe, achPaymentMethod]);

  const enableCreditCardPaymentMethod = useMemo(() => {
    return paymentMethod?.allow_member;
  }, [paymentMethod]);


  const initialActivePayment = useMemo(() => {
    if(!enableAchPaymentMethod && !enableCreditCardPaymentMethod) return null;
    if(!enableAchPaymentMethod) return "credit-card";
    if(!enableCreditCardPaymentMethod) return "ach";
    return activePaymentParams || "credit-card";
  }, [enableAchPaymentMethod, activePaymentParams]);

  
  const { getAccessTokenSilently } = useAuth0();
  const [activePayment, setActivePayment] = useState(initialActivePayment);



  const getUserAccount = async () => {
    let accountId;
    const token = await getAccessTokenSilently();
    await AuthService.getUserExist(token)
      .then((res) => {
        if (res) {
          localStorage.setItem("accountID", res?.user?.permissions?.linked_account?._id);
          accountId = res?.user?.permissions?.linked_account?._id;
        }
      })
      .catch((err) => {
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      });

      return accountId;
  };





  const paymentTabs = [
    ...(enableCreditCardPaymentMethod ? [{
      label: "Credit Card",
      value: "credit-card",
    }] : []),
    ...(enableAchPaymentMethod ? [{
      label: "ACH",
      value: "ach",
    }] : []),
  ];

  return (
    <div className="profile-container">
      <div className="edit-profile-container">
        <div className="profile-header">
          <div>
            <div className="main-text">Payment Methods</div>
            <div className="body-text">Manage your Payment Methods</div>
          </div>
        </div>
        <hr />
        <div className="profile-body">
          {paymentTabs.length > 1 && (
            <RadioButtons
                value={activePayment}
                name={"activePayment"}
                row={true}
                onChange={(value) => {
                  setActivePayment(value);
                }}
                size={"small"}
                options={paymentTabs}
            />
          )}
          {activePayment === "credit-card" && (
            <CreditCardMethod 
              getUserAccount={getUserAccount}
            />
          )}
          {activePayment === "ach" && (
            <AchMethod />
          )}
        </div>
      </div>

    </div>
  );
};

export default withUserExist(PaymentMethods);
